export default __webpack_public_path__ + "media/images/blank_avatar-cabe22e7ec3a5acc52293a1bf664c3c9.png";